export interface SnackBarInfo {
  message: string;
  action: SnackbarActionType;
}

export enum SnackbarActionType {
  Cancel = 'Cancel',
  Done = 'Done',
  Dismiss = 'Dismiss',
  Refresh = 'refresh',
}
